import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class OperatingexpensesService {
  constructor(private http: Http) {}

  private baseurl = environment.apiBaseUrl;

  // update value of opex's input fields onchange event
  updateValue(data) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/updateValue`, { data })
      .map((res: Response) => res.json());
  }

  // to save cashflow's 120 month data
  updateCashFlow(data) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/saveCashFlow`, { data })
      .map((res: Response) => res.json());
  }

  // update seller's data in recast page onchange event
  updateSeller(id, data) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/updateSellerValue`, { id, data })
      .map((res: Response) => res.json());
  }

  // to get opex page's data year vise i.e input fields saved data
  getRecords(projectId, year) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/getRecords`, { projectId, year })
      .map((res: Response) => res.json());
  }

  // get ten years saved data of opex
  tenYearsRecords(data) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/tenYearsRecords`, { data })
      .map((res: Response) => res.json());
  }

  // to get opex page's all 120 months data i.e input fields saved data
  getAllRecords(projectId) {
    return this.http
      .post(`${this.baseurl}/operatingexpenses/getAllRecords`, { projectId })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/operatingexpenses.service.ts